module.exports = "/_next/static/images/about-the-product-kit-diputi@2x-min-49f476d85e0d7138b0406cd34ee150de.png";